<template>
  <div>

 
    <div class="w-full h-10 bg-black lg:fixed lg:inset-y-0">
      
    </div>
    <div class="bg-cover bg-center w-full min-h-screen flex items-center justify-center radial-gradient"  >
      <div class="min-h-full flex flex-col">
        <div class="m-1 lg:mt-12 xl:mt-6 sm:mx-auto sm:w-full sm:max-w-md">
          <div class="flex items-center justify-center text-center ">
         
          </div>
          <span v-if="!visible">Switching to English</span>
        </div>

        <div v-if="visible" class="pt-1 sm:mx-auto sm:w-full sm:max-w-md">
          <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-6 lg:px-6">

            <form class="space-y-6" @submit.prevent="handleSubmit"> 
                    <div class="flex items-center justify-center text-center p-3 text-blue-800">
                    <span v-if="qrDataUrl" class="font-mono text-sm">
                     Usa la aplicación Google Authenticator o Microsoft Authenticator para escanear el código QR.
                     
                     Esto conecta a la aplicación con tu cuenta.
                     <br><br>
                     Después vuelve y selecciona Siguiente
                    </span>
                    </div>
                     <div class="flex justify-center">
                      <img v-if="qrDataUrl" :src="qrDataUrl" alt="QR OTP"   />
                    </div>
                    
                    <button type="submit"   class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                    Siguiente
                    </button>
            </form>    
        
        </div>

          
        </div>
      </div>
    </div>
    <div v-if="isOnline == false" class="sticky bottom-0 bg-red-500 text-white text-center py-4"
      style='z-index:10000000'>
      <p>{{ $t('sinconexion') }}</p>
    </div>
  </div>
</template>
<style>
.radial-gradient {
   
    background: radial-gradient(circle, rgb(171, 217, 255), rgb(210, 214, 246), rgb(122,160,195));
    background-size: 400% 400%;
    animation: gradient 15s ease infinite;
}

@keyframes gradient {
    0% {
        background-position: 0% 50%;
    }
    50% {
        background-position: 100% 50%;
    }
    100% {
        background-position: 0% 50%;
    }
}
</style>

<script>
import { ref } from 'vue'
import { mapActions } from "vuex";
 import router from "../../router";
 
 
import i18n from '@/i18n';
import QRCode from 'qrcode'
export default {
  name: "OtpSetupQr",
  components: {
 
  },
  created() {
    this.checkInternet();
    window.addEventListener("online", this.checkInternet);
    window.addEventListener("offline", () => (this.isOnline = false));
  },
  mounted() {
    console.warn('tokens', this.$store.state.auth.tokens)
     if ( typeof( this.$store.state.auth.tokens)  === "undefined"  || this.$store.state.auth.tokens=='' ) 
     {
      router.push("/");
      console.log("sin definir status login");
      return false;
    } 
    this.loadQr()
  },
  data() {
    return {
      visible:true,
      type0: 'password',
      isOnline: false,
      showRecaptcha: true,
      loadingTimeout: 30000, // 30 seconds
      userName: "",
      password: "",
      showModal: false,
      status: "0",
      token: "",
      mensaje: "",
      verificado: false,
      keycliente: "6LdgnAcpAAAAAJHBHchPcK5qJjGc1oEa55pFpJTr",
      showDropdown: false,
      dropdownRef: { value: ref(null) },
      btnText0: ref(i18n.global.t('mostrar')),
      hl: '',
      err_password:false,
      err_username:false,
      qrDataUrl:''
    };
  },
  methods: {
    ...mapActions("auth", ["login"]),
    handleSubmit(){
        router.push('/OtpSetupCode')
    },  
    async loadQr(){
         this.qrDataUrl=   await QRCode.toDataURL( this.$store.state.auth.QR);
    },
     
    async checkInternet() {
      try {

        await fetch("https://www.google.cl", { mode: "no-cors" });
        this.isOnline = true;
      } catch (error) {
        this.isOnline = false;
      }
    },
  


  
  

  
  },
  watch: {
    async hl(value) {
      this.reloadRecaptchaScript(value)

    },
  },

}
</script>
